// extracted by mini-css-extract-plugin
module.exports =  {"descriptionElements":"F7CjAHZNox4rQbwPjVeM","chip":"Iaq4kozxG2KNJddNTFBw","avatar":"ty8iXWCSEJskeVPFn0yl"};